import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Nav from './components/Navbar/Nav';
import Footer from './components/Footer/Footer';
import './DarkMode.css';
import Main from './Main';
import AdminPanel from './admin/AdminPanel';
import { DarkModeProvider } from './context/DarkModeContext';
import { ContentProvider } from './context/ContentContext';

function App() {
  return (
    <ContentProvider>
      <DarkModeProvider>
      <Router>
        <Routes>
          <Route path="/josecms" element={<AdminPanel />} />
          <Route path="/" element={
            <div className="App">
              <Nav />
              <div className="App-content">
                <Main />
              </div>
              <Footer />
            </div>
          } />
        </Routes>
      </Router>
    </DarkModeProvider>
    </ContentProvider>
  );
}

export default App;
